import { validateWidgetSettings } from "./common";
import * as enums from "./enums";

export class SoundManager {
  static widgetSettings;
  static incomingCallAudio = null;
  static outgoingCallAudio = null;
  static incomingMessageAudio = null;
  static outgoingMessageAudio = null;
  static incomingOtherMessageAudio = null;

  static loadAudio = async (type) => {
    throw new Error(`SoundManager.loadAudio("${type}") is not implemented.`);
  };

  static setWidgetSettings = (widgetSettings) => {
    this.widgetSettings = widgetSettings;
  };

  static play = async (action) => {
    switch (action) {
      case enums.CONSTANTS.AUDIO["INCOMING_CALL"]: {
        this.incomingCallAudio =
          this.incomingCallAudio ||
          new Audio(await this.loadAudio("incomingcall"));
        this.playCallAlert(this.incomingCallAudio);
        break;
      }
      case enums.CONSTANTS.AUDIO["OUTGOING_CALL"]: {
        this.outgoingCallAudio =
          this.outgoingCallAudio ||
          new Audio(await this.loadAudio("outgoingcall"));
        this.playCallAlert(this.outgoingCallAudio);
        break;
      }
      case enums.CONSTANTS.AUDIO["INCOMING_MESSAGE"]: {
        this.incomingMessageAudio =
          this.incomingMessageAudio ||
          new Audio(await this.loadAudio("incomingmessage"));
        this.playMessageAlert(this.incomingMessageAudio);
        break;
      }
      case enums.CONSTANTS.AUDIO["INCOMING_OTHER_MESSAGE"]: {
        this.incomingOtherMessageAudio =
          this.incomingOtherMessageAudio ||
          new Audio(await this.loadAudio("incomingothermessage"));
        this.playMessageAlert(this.incomingOtherMessageAudio);
        break;
      }
      case enums.CONSTANTS.AUDIO["OUTGOING_MESSAGE"]: {
        this.outgoingMessageAudio =
          this.outgoingMessageAudio ||
          new Audio(await this.loadAudio("outgoingmessage"));
        this.playMessageAlert(this.outgoingMessageAudio);
        break;
      }
      default:
        break;
    }
  };

  static pause = (action) => {
    //if audio sound is disabled in chat widget
    if (
      validateWidgetSettings(this.widgetSettings, "enable_sound_for_calls") ===
      false
    ) {
      return false;
    }

    switch (action) {
      case enums.CONSTANTS.AUDIO["INCOMING_CALL"]: {
        if (this.incomingCallAudio) {
          this.incomingCallAudio.pause();
        }
        break;
      }
      case enums.CONSTANTS.AUDIO["OUTGOING_CALL"]: {
        if (this.outgoingCallAudio) {
          this.outgoingCallAudio.pause();
        }
        break;
      }
      case enums.CONSTANTS.AUDIO["INCOMING_MESSAGE"]:
      case enums.CONSTANTS.AUDIO["INCOMING_OTHER_MESSAGE"]:
      case enums.CONSTANTS.AUDIO["OUTGOING_MESSAGE"]:
      default:
        break;
    }
  };

  static playCallAlert = (callAudio) => {
    try {
      callAudio.currentTime = 0;
      if (typeof callAudio.loop == "boolean") {
        callAudio.loop = true;
      } else {
        callAudio.addEventListener(
          "ended",
          function () {
            this.currentTime = 0;
            this.play();
          },
          false
        );
      }
      callAudio.play();
    } catch (error) {}
  };

  static pauseCallAlert = (callAudio) => {
    callAudio.pause();
  };

  static playMessageAlert = (messageAudio) => {
    messageAudio.currentTime = 0;
    messageAudio.play();
  };

  static pauseMessageAlert = (messageAudio) => {
    messageAudio.pause();
  };
}
